import React, { Component } from 'react'
import { Route, Routes } from 'react-router-dom'
import { DashboardH } from './Dashboard'
import Home from './Home'
import { LoginH } from './Login'
import Pricing from './Pricing'

export default class RouterComponents extends Component {
  render() {
    return (
      <React.Fragment>

      <Routes>
        <Route path='/' element={<Home/>}></Route>
        <Route path='/Pricing' element={<Pricing/>}></Route>
        <Route path='/Login' element={<LoginH/>}></Route>
        <Route path='/Dashboard' element={<DashboardH/>}></Route>
      </Routes>
      </React.Fragment>
    )
  }
}
